import { render } from "./discharge-report-filter.vue?vue&type=template&id=fef6be24&ts=true"
import script from "./discharge-report-filter.vue?vue&type=script&lang=ts"
export * from "./discharge-report-filter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__